export default "__VITE_ASSET__57dbd1bc__"